import React, { useRef } from "react";
import { Search, X } from "lucide-react";

interface InventoryFiltersProps {
    searchQuery: string;
    onSearchChange: (query: string) => void;
    onClearSearch: () => void;
}

export const InventoryFilters: React.FC<InventoryFiltersProps> = ({
    searchQuery,
    onSearchChange,
    onClearSearch,
}) => {
    const searchInputRef = useRef<HTMLInputElement>(null);

    const handleClearSearch = () => {
        onClearSearch();
        setTimeout(() => searchInputRef.current?.focus(), 0);
    };

    // Plain search field — no wrapping card.
    return (
        <div className="relative max-w-sm mb-5">
            <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 w-4 h-4 pointer-events-none" />
            <input
                ref={searchInputRef}
                type="text"
                placeholder="Search by name or SKU…"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-full pl-10 pr-9 py-2.5 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500/40 focus:border-blue-500 transition-colors"
            />
            {searchQuery && (
                <button
                    onClick={handleClearSearch}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
                    aria-label="Clear search"
                >
                    <X className="w-4 h-4" />
                </button>
            )}
        </div>
    );
};
